import React, { useState, useEffect, useContext } from 'react';
import { NotificationContext } from '../../context/NotificationContext';
import api from '../../api';

const FormManager = ({ configId }) => {
  const { showNotification } = useContext(NotificationContext);
  const [forms, setForms] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    form_url: ''
  });

  useEffect(() => {
    loadForms();
  }, [configId]);

  const loadForms = async () => {
    try {
      const response = await api.get(`/admin/forms/${configId}`);
      setForms(response.data);
    } catch (error) {
      showNotification('Error loading forms: ' + error.message, true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const submissionData = {
        configuration_id: parseInt(configId),
        form_url: formData.form_url
      };

      await api.post('/admin/forms/', submissionData);
      showNotification('Form added successfully!');
      setIsModalOpen(false);
      setFormData({
        form_url: ''
      });
      loadForms();
    } catch (error) {
      showNotification('Failed to add form: ' + error.message, true);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this form?')) return;

    try {
      await api.delete(`/admin/forms/${id}`);
      showNotification('Form deleted successfully!');
      loadForms();
    } catch (error) {
      showNotification('Failed to delete form: ' + error.message, true);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="section-card">
      <div className="section-header">
        <h2>Forms</h2>
        <button 
          className="add-entity-btn"
          onClick={() => setIsModalOpen(true)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd"/>
          </svg>
          <span>Add Form</span>
        </button>
      </div>
      
      <div className="section-content">
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Form URL</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {forms.length === 0 ? (
                <tr>
                  <td colSpan="2" className="text-center py-4 text-gray-500">
                    No forms found.
                  </td>
                </tr>
              ) : (
                forms.map(form => (
                  <tr key={form.id}>
                    <td>{form.form_url}</td>
                    <td>
                      <button 
                        onClick={() => handleDelete(form.id)}
                        className="text-red-600 hover:text-red-800 font-medium"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && (
        <div className="section-modal">
          <button 
            className="modal-close"
            onClick={() => setIsModalOpen(false)}
          >
            ×
          </button>
          <h3>Add Form</h3>
          <form onSubmit={handleSubmit}>
            <div>
              <label className="form-label">Form URL</label>
              <input
                type="url"
                name="form_url"
                value={formData.form_url}
                onChange={handleInputChange}
                className="form-input"
                required
                placeholder="Enter form URL"
              />
            </div>
            <div className="modal-actions">
              <button type="button" onClick={() => setIsModalOpen(false)}>
                Cancel
              </button>
              <button type="submit" disabled={loading}>
                {loading ? 'Adding...' : 'Add Form'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default FormManager; 